<script>

import MapBoxDisplay from "./Geography/MapBoxDisplay.vue";

import axios from "axios";

export default {
  name: 'OverlapTerminal',
  components: {MapBoxDisplay},
  props: {
    mapboxKey: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      activeOverlapId: null,
      overlapData: {},
      overlaps: [],
      includedTrashed: 0,
      pagination: {},
    }
  },
  watch: {
    includedTrashed(newVal) {
      this.getOverlaps(newVal)
    },
  },
  mounted() {
    this.getOverlaps()
  },
  methods: {
    showOverlap(overlap, isTrashed) {
      this.activeOverlapId = null
      this.overlapData = null
      axios.get('/overlaps/' + (isTrashed ? 'trashed/' : '') + overlap).then((response) => {
        this.overlapData = response.data;
        this.activeOverlapId = overlap
      })
    },
    getOverlaps(includeTrashed = false) {
      axios.get('/overlaps/list' + (includeTrashed ? '?trashed=1' : '')).then((response) => {
        this.pagination = response.data;
        this.overlaps = this.pagination.data
        this.showOverlap(this.overlaps[0].id, !!this.overlaps[0].deleted_at)
      })
    },
    accept(overlap) {
      axios.delete('/overlaps/' + overlap.id).then((response) => {
        if (this.includedTrashed) {
          overlap.deleted_at = true
        } else {
          const index = this.overlaps.findIndex(x => x.id === overlap.id);
          if (index > -1) {
            this.overlaps.splice(index, 1);
            if (this.overlaps[index]) {
              this.showOverlap(this.overlaps[index].id, !!this.overlaps[index].deleted_at)
            } else {
              this.activeOverlapId = null
            }
          }
        }
      })
    },
    unaccept(overlap) {
      axios.post('/overlaps/' + overlap.id + '/restore').then((response) => {
        overlap.deleted_at = null
      })
    },
    nextPage() {
      axios.get(this.pagination.next_page_url).then((response) => {
        this.pagination = response.data;
        this.overlaps = this.overlaps.concat(this.pagination.data)
      })
    },
    getMapSource() {
      if (this.overlapData && this.overlapData.boundary && this.overlapData.fieldYears.length > 0) {
        return [{
          id: 'field_year_0',
          color: '#008ED3',
          geography: this.overlapData.boundary.features[0],
        }, {
          id: 'field_year_1',
          color: '#ef5753',
          geography: this.overlapData.boundary.features[1],
        }]
      }
      return null
    }
  }
}
</script>

<template>
  <div class="w-full text-white h-screen mb-32">
    <div>
      <div class="flex flex-row bg-grey-darker p-4">
        <h1>Field Overlaps <span class="text-grey-light"
                                              v-if="pagination">(Count: {{ pagination.total }})</span></h1>
        <button class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold mr-2 ml-auto" @click="includedTrashed=(includedTrashed+1)%2">
          <span v-show="includedTrashed">Exclude</span><span v-show="!includedTrashed">Include</span> Accepted
        </button>
      </div>
      <div class="flex flex-row h-full">
        <div class="w-1/5 overflow-y-scroll" style="height: 800px;">
          <div class="bg-grey-dark w-full border-r border-grey-darker h-full flex">
            <div class="flex flex-col w-full overflow-y-scroll" v-if="overlaps.length>0">
              <button type="button"
                      :class="overlap && (overlap.id == activeOverlapId) ? `rounded-none w-full border-2 border-grey-dark`:`btn rounded-none btn-secondary w-full border-2 border-grey`"
                      v-for="overlap in overlaps" @click="showOverlap(overlap.id, !!overlap.deleted_at)">
                <div class="text-center flex flex-row mx-2 my-1">
                  <div class="border-r-2 pr-2 mr-2">{{ overlap.id }}</div>
                  <div class="border-r-2 pr-2 mr-2">IDS: {{ overlap.field_year_1_id }},
                    {{ overlap.field_year_2_id }}
                  </div>
                  <div>Acres: <span class="font-semibold">{{ overlap.acres }}</span></div>
                </div>
              </button>
              <button type="button"
                      v-if="this.pagination.next_page_url"
                      class="btn rounded-none btn-secondary w-full border-2 border-grey-dark text-center"
                      @click="nextPage()">
                <div class="text-center flex flex-row">
                  More...
                </div>
              </button>
            </div>
            <div v-else class="p-4">
              No overlaps to review.
            </div>
          </div>
        </div>
        <div class="w-4/5 overflow-y-scroll" style="height: 800px;">
          <div class="bg-grey-dark w-full h-full p-4">
            <div v-show="activeOverlapId && overlapData">
              <h2>Overlap {{ activeOverlapId }}</h2>
              <div class="mb-4 text-black">
                <MapBoxDisplay
                    :sources="getMapSource()"
                    :token="mapboxKey" :render="false"
                    ref="overlap_map"></MapBoxDisplay>
              </div>

              <div v-if="overlapData && activeOverlapId" class="grid grid-cols-2">
                <div>
                  <span class="font-semibold mb-2">Overlap ID: </span> {{ overlapData.overlap.id }}
                </div>
                <div class="text-right mb-2">
                  <span class="font-semibold">Overlap Size: </span> {{ overlapData.overlap.acres }}
                </div>
                <div>
                  <div v-if="overlapData.fieldYears" class="flex flex-col">
                    <template v-for="(fieldYear,index) in overlapData.fieldYears">
                      <a :href="fieldYear.url" class="mb-1">
                        <span :class="`box-border px-2  mr-2 ` + `bg-`+['blue','red-light'][index]"></span>
                        <span class="text-white">
                        {{ fieldYear.farm_name }}, {{ fieldYear.name }}, {{
                            fieldYear.year_name
                          }}
                        </span>
                      </a>
                    </template>
                  </div>
                </div>
                <div class="text-right">
                  <div v-if="overlapData.overlap.deleted_at">
                    <button type="button" class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker font-bold mr-2" @click="unaccept(overlapData.overlap)">Unaccept
                    </button>
                  </div>
                  <div v-else>
                    <button type="button" class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker font-bold mr-2" @click="accept(overlapData.overlap)">Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
